import React, { useEffect, useState } from 'react'
import Title from '../../../components/panelcontrols/paneltitle'
import OrderTable from './orderTable'
import OrderStatusSelector  from './orderStatusSelector'
import OrderFunctions from '../orders/list/functions'
import './index.css'

const ITEMS_PER_PAGE = 20;

const Index = () => {
  const [selectedStatus,setSelectedStatus] = useState(0);
  const [orderList,setOrderList] = useState([]);
  const [currentPage,setCurrentPage] = useState(1);
  const [paginationInfo,setPaginationInfo] = useState({
    totalPages: 1,
    currentPage: 1,
    totalRecords: 0
  });

  const fetchOrders = (page) => {
    if(selectedStatus === 0){
      OrderFunctions.GetPaginated(page, ITEMS_PER_PAGE, setOrderList, setPaginationInfo)
    }
    else{
      OrderFunctions.GetByStatusPaginated(selectedStatus, page, ITEMS_PER_PAGE, setOrderList, setPaginationInfo)
    }
  }

  useEffect(()=>{
    setCurrentPage(1);
    fetchOrders(1);
  },[selectedStatus])

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchOrders(newPage);
  }

  return (
    <div className='labadmin_dashboard_container'>
      <Title Value={'Dashboard'}/>
      <OrderStatusSelector selectedStatus={selectedStatus} setSelectedStatus={setSelectedStatus}/>
      <OrderTable 
        List={orderList} 
        currentPage={currentPage} 
        totalPages={paginationInfo.totalPages}
        totalRecords={paginationInfo.totalRecords}
        onPageChange={handlePageChange}
      />
    </div>
  )
}

export default Index
